import i18next from "i18next";
import { HistoryActivityActionEnum } from "Data/interfaces/History/IHistoryActivityApi";
import { activitiesContentOptions } from "./ActivityOptions";
import { HistoryActivityActionDescriptionRecord, HistoryActivityIconRecord } from "Data/interfaces/History/IHistoryActivityRecord";

const contentActivityIcon: HistoryActivityIconRecord = {
  [HistoryActivityActionEnum.TopicCreated]: { icon: 'activities' },
  [HistoryActivityActionEnum.TopicStatusUpdated]: { icon: 'trocarStatus' },
  [HistoryActivityActionEnum.TopicUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicTitleUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicCommunicationTypeUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicDescriptionUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicAssignedUsersUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicDisciplinesUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicDueDateUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicVisibilityUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicPriorityUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicLocationUpdated]: { icon: 'editar' },
  [HistoryActivityActionEnum.TopicAttachmentAdded]: { icon: 'paperclip' },
  [HistoryActivityActionEnum.TopicAttachmentDeleted]: { icon: 'paperclip' },
  [HistoryActivityActionEnum.TopicStageUpdated]: { icon: 'editar' },
}
const actionActivityDescription: HistoryActivityActionDescriptionRecord = {
  get [HistoryActivityActionEnum.TopicCreated]() { return i18next.t('activities:history.topicCreated'); },
  get [HistoryActivityActionEnum.TopicStatusUpdated]() { return i18next.t('activities:history.topicStatusUpdated'); },
  get [HistoryActivityActionEnum.TopicTitleUpdated]() { return i18next.t('activities:history.topicTitleUpdated'); },
  get [HistoryActivityActionEnum.TopicCommunicationTypeUpdated]() { return i18next.t('activities:history.topicCommunicationTypeUpdated'); },
  get [HistoryActivityActionEnum.TopicDescriptionUpdated]() { return i18next.t('activities:history.topicDescriptionUpdated'); },
  get [HistoryActivityActionEnum.TopicAssignedUsersUpdated]() { return i18next.t('activities:history.topicAssignedUsersUpdated'); },
  get [HistoryActivityActionEnum.TopicDisciplinesUpdated]() { return i18next.t('activities:history.topicDisciplinesUpdated'); },
  get [HistoryActivityActionEnum.TopicDueDateUpdated]() { return i18next.t('activities:history.topicDueDateUpdated'); },
  get [HistoryActivityActionEnum.TopicVisibilityUpdated]() { return i18next.t('activities:history.topicVisibilityUpdated'); },
  get [HistoryActivityActionEnum.TopicPriorityUpdated]() { return i18next.t('activities:history.topicPriorityUpdated'); },
  get [HistoryActivityActionEnum.TopicLocationUpdated]() { return i18next.t('activities:history.topicLocationUpdated'); },
  get [HistoryActivityActionEnum.TopicAttachmentAdded]() { return i18next.t('activities:history.topicAttachmentAdded'); },
  get [HistoryActivityActionEnum.TopicAttachmentDeleted]() { return i18next.t('activities:history.topicAttachmentDeleted'); },
  get [HistoryActivityActionEnum.TopicStageUpdated]() { return i18next.t('activities:history.topicStageUpdated'); },
} as HistoryActivityActionDescriptionRecord;

export {
  activitiesContentOptions,
  contentActivityIcon,
  actionActivityDescription,
};
